import React from 'react';
import { IconFont } from '../IconFont';
import './style.less';

type BadgeStatus = 'success' | 'warning' | 'error' | 'info' | 'default' | 'disabled';
type BadgeVariant = 'outline' | 'light' | 'solid';

interface BadgeProps {
  status?: BadgeStatus;
  variant?: BadgeVariant;
  icon?: string; // IconFont 的 type，例如 "g-check"
  children?: React.ReactNode;
  className?: string;
  style?: React.CSSProperties;
}

const Badge: React.FC<BadgeProps> = ({
  status = 'default',
  variant = 'light',
  icon,
  children = '',
  className = '',
  style,
}) => {
  const renderIcon = () => {
    if (icon) {
      return <IconFont type={icon} className="badge-icon"/>;
    }
    return <span className="badge-dot"/>;
  };

  return (
      <span className={`badge badge-${status} badge-${variant} ${className}`} style={style}>
      {renderIcon()}
        <span>{children}</span>
    </span>
  );
};

export { Badge };
